import React from 'react';
import { useFooterData } from '@interness/web-core/src/hooks';
import Widgets from '@interness/web-core/src/components/modules/Widgets';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultWidgets = [{
  sort: 1,
  widget_name: 'address',
  position: 'footer',
  props: {
    showLogo: true
  },
  translations: [{
    language: 'de',
    header: 'Adresse'
  }]
}, {
  sort: 2,
  widget_name: 'contact',
  position: 'footer',
  props: {},
  translations: [{
    language: 'de',
    header: 'Kontakt'
  }]
}, {
  sort: 3,
  widget_name: 'openingHours',
  position: 'footer',
  props: {},
  translations: [{
    language: 'de',
    header: 'Öffnungszeiten'
  }]
}, {
  sort: 4,
  widget_name: 'navigation',
  position: 'footer',
  props: {},
  translations: [{
    language: 'de',
    header: 'Rechtliches'
  }]
}];
function Footer() {
  const data = useFooterData();
  const widgets = data.widgets.length > 0 ? data.widgets : defaultWidgets;
  return ___EmotionJSX(S.FooterWrapper, null, ___EmotionJSX(S.Footer, null, ___EmotionJSX(S.Inner, {
    widgetsCount: widgets.length
  }, ___EmotionJSX(Widgets, {
    widgets: widgets,
    lang: data.language
  }))));
}
export default Footer;